import axios from 'axios';
import React, {useEffect, useState} from 'react';
import {votingCategories} from './Voting';
import {olderResults} from './oldResults';

const olderResultsYears = [
	'2021',
	'2020',
	'2019',
	'2018',
	'2017',
	'2016',
	'2015',
	'2014',
	'2013',
	'2012',
	'2011',
	'2010',
	'2009',
];

const calculateOldResultsYears = (currentYear) => {
	const oldResultsYears = [];
	const yearOfTheLastSummary = 2022;
	const yearsBetween = currentYear - yearOfTheLastSummary;
	for (let i = 0; i <= yearsBetween - 2; i++) {
		oldResultsYears.push(`${yearOfTheLastSummary + i}`);
	}
	return oldResultsYears;
};

const Results = () => {
	const [lastYearResults, setLastYearResults] = useState([]);
	const [oldResults, setOldResults] = useState([]);
	const currentYear = new Date().getFullYear();
	const oldResultsYears = calculateOldResultsYears(currentYear);
	const getLastYearResults = async () => {
		await axios
			.get(`${process.env.REACT_APP_API}/show-lastyear-results`)
			.then((result) => {
				setLastYearResults(result.data);
			});
	};
	const getOldResults = async () => {
		await axios
			.get(`${process.env.REACT_APP_API}/show-old-results`)
			.then((result) => {
				setOldResults(result.data);
			});
	};

	useEffect(() => {
		getLastYearResults();
		getOldResults();
	}, []);
	return (
		<>
			<div className='p-5 mx-5 bg-gradient-to-b from-[#e2ce9d] to-[#f9b866]'>
				<div className='max-w-5xl mx-auto'>
					<div className='mx-auto mt-5 text-center text-2xl font-[Bold] text-[#503854]'>
						WYNIKI
					</div>

					<div className='p-1 w-full mt-5 drop-shadow-xl bg-[#503854] rounded' />
					<div className='p-2 mt-5 text-center font-[Light]'>
						MOŻECIE TUTAJ SPRAWDZIĆ ZWYCIĘZCÓW WSZYSTKICH
						POPRZEDNICH EDYCJI.{' '}
					</div>
					{/* <>
          <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]">
            <div className="p-1 font-[Bold] uppercase text-gray-50">
              {currentYear - 1}
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mt-2">
            {votingCategories.map((votingCategory) => {
              return lastYearResults
                .filter((votingCard) => votingCard._id === votingCategory)
                .map((lastYearResult) => {
                  const category = lastYearResult._id;
                  const data = lastYearResult.data;
                  switch (category) {
                    case "teledysk":
                      return (
                        <div className=" max-w-md drop-shadow-lg">
                          {data.map((resultData, i) => {
                            return i === 0 ? (
                              <div
                                className={`flex flex-row flex-wrap w-fit h-46 relative z-20 justify-evenly border-[#503854] border-2 border-solid text-stone-200 drop-shadow-xl rounded bg-gradient-to-t from-[#f9b866] to-[#503854]`}
                              >
                                <div className="relative flex flex-col-reverse justify-end drop-shadow-2xl">
                                  <div className="w-fit mx-2 font-[Light] text-l uppercase">
                                    {category}
                                  </div>
                                  <div className="w-fit mx-2 pr-20 font-[Bold] text-xl">
                                    {resultData.name}
                                  </div>
                                </div>
                                <div className="flex flex-col-reverse mb-[1px] w-full text-end font-[Bold] text-xl">
                                  <div className="h-6 w-full self-end text-center mb-[7px]">
                                    <div className="text-[#503854] text-right mr-1">
                                      {resultData.votesPercentage + "%"}
                                    </div>
                                    <div className="w-full h-1 rounded-full bg-[#5038544a] float-right">
                                      <div
                                        className={`h-1 rounded-full bg-[#503854] float-right`}
                                        style={{
                                          width: `${resultData.votesPercentage}%`,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="mx-1 self-end">
                                    {
                                      <iframe
                                        src={`https://www.youtube-nocookie.com/embed/${resultData.video}?enablejsapi=1`}
                                        className="border-[#503854] border-2 rounded"
                                        title="YouTube video player"
                                        allowFullScreen={true}
                                        referrerPolicy="no-refferer"
                                        sandbox="allow-scripts allow-same-origin"
                                        loading="lazy"
                                      />
                                    }
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className={`flex flex-col border-x min-h-[85px] relative pt-1 w-50 ${
                                  i === 1 && "z-10"
                                } text-[#503854] justify-between -mt-1 bg-[#f9b866] border-[#503854] border-b ${
                                  i === 2 &&
                                  "bg-gradient-to-b from-[#f9b866] to-[#e2ce9d]"
                                } rounded`}
                              >
                                <div className="border-solid border-black self-start w-fit mx-2 font-[Bold] text-l">
                                  {resultData.name}
                                </div>
                                <div className="w-full self-end font-[Bold] text-xl">
                                  <div className="text-right mr-1">
                                    {resultData.votesPercentage + "%"}
                                  </div>
                                  <div className="w-full h-1 rounded-full bg-[#5038544a]">
                                    <div
                                      className={`h-1 rounded-full bg-[#503854] float-right`}
                                      style={{
                                        width: `${resultData.votesPercentage}%`,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    default:
                      return (
                        <div className="w-80 drop-shadow-lg">
                          {data.map((resultData, i) => {
                            return i === 0 ? (
                              <div className="flex flex-col w-50 h-40 relative z-20 justify-between border-[#503854] border-2 border-solid text-stone-200 drop-shadow-xl rounded bg-gradient-to-t from-[#f9b866] to-[#503854]">
                                <div
                                  className={`flex flex-row relative z-20 justify-between  `}
                                >
                                  <div className="relative flex flex-col-reverse justify-end drop-shadow-2xl">
                                    <div className="w-fit mx-1 font-[Light] text-l uppercase">
                                      {category}
                                    </div>
                                    <div className="w-fit mx-1 font-[Bold] text-l">
                                      {resultData.name}
                                    </div>
                                  </div>
                                  <div className="mr-1 w-fit flex flex-col-reverse text-center self-center font-[Light] text-xl">
                                    <div className="w-32 text-xl">
                                      <img
                                        className="w-32 rounded border-[#503854] border-2"
                                        src={`${process.env.REACT_APP_API_DOMAIN}/images/${resultData.image}`}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="text-[#503854] font-[Bold] text-xl text-right mr-1 -mb-1">
                                  {resultData.votesPercentage + "%"}
                                </div>
                                <div className="w-full rounded-full h-1 bg-[#5038545b]">
                                  <div
                                    className={`h-1 rounded-full bg-[#503854] float-right`}
                                    style={{
                                      width: `${resultData.votesPercentage}%`,
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ) : (
                              <div
                                className={`flex flex-col border-x min-h-[85px] relative pt-1 w-50 ${
                                  i === 1 && "z-10"
                                } text-[#503854] justify-between -mt-1 bg-[#f9b866] border-[#503854] border-b ${
                                  i === 2 &&
                                  "bg-gradient-to-b from-[#f9b866] to-[#e2ce9d]"
                                } rounded`}
                              >
                                <div className="border-solid border-black self-start w-fit mx-2 font-[Bold] text-l">
                                  {resultData.name}
                                </div>
                                <div className="w-full self-end font-[Bold] text-xl">
                                  <div className="text-right mr-1">
                                    {resultData.votesPercentage + "%"}
                                  </div>
                                  <div className="w-full h-1 rounded-full bg-[#5038544a]">
                                    <div
                                      className={`h-1 rounded-full bg-[#503854] float-right`}
                                      style={{
                                        width: `${resultData.votesPercentage}%`,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                  }
                });
            })}
          </div></> */}

					<div className='p-2 flex flex-wrap justify-around mt-5 drop-shadow-xl bg-[#503854] rounded  font-[Light]'>
						{votingCategories.map((category) => {
							return (
								<div
									className='p-2 font-[Bold] uppercase text-gray-50'
									key={category + category}
								>
									{category} roku
								</div>
							);
						})}
					</div>

					<div className='text-center text-sm uppercase text-white font-[Bold] mt-2'>
						<div className='p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]'>
							<div className='p-1 font-[Bold] uppercase text-gray-50'>
								{lastYearResults.length > 0
									? currentYear
									: currentYear - 1}
							</div>
						</div>
						{/* <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
                />
                <div className="font-[Bold] mt-2">???</div>
              </div>
            </div> */}
						{/* <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]">
              <div className="p-1 font-[Bold] uppercase text-gray-50">
                {currentYear - 2}
              </div>
            </div> */}

						{/* ??? row */}
						<div className='flex flex-wrap justify-around'>
							{votingCategories.flatMap((votingCategory, i) => {
								return (
									<div
										key={i + votingCategory + i}
										className='border-solid border-2 border-[#503854] text-[#ffffff] bg-gradient-to-t from-[#f9b866] to-[#503854] rounded p-1 w-[140px] h-fit flex flex-col flex-wrap justify-between mt-3 shadow-xl  font-[Light]'

									>
										<div className='-mt-1'>
											{votingCategory}
										</div>
										<img
											className='rounded'
											src={`${process.env.REACT_APP_API_DOMAIN}/images/unknown.jpg`}
										/>
										<div className='font-[Bold] mt-2 text-black'>
											???
										</div>
									</div>
								);
							})}
						</div>

						{lastYearResults.length > 0 && (
							<div className='text-center text-sm uppercase text-white font-[Bold] flex flex-wrap justify-around'>
								<div className='w-full'>
									<div className='p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]'>
										<div className='p-1 font-[Bold] uppercase text-gray-50'>
											{currentYear - 1}
										</div>
									</div>
									<div className='flex flex-wrap justify-center gap-2 mt-2'>
										{/* last results */}
										{votingCategories.map(
											(votingCategory) => {
												const shouldReturnResults = false;
												const shouldReturnPercentage = false;

												return lastYearResults
													.filter(
														(votingCard) =>
															votingCard._id ===
															votingCategory
													)
													.map((lastYearResult) => {
														const category =
															lastYearResult._id;
														const data =
															lastYearResult.data;
														switch (category) {
															case 'teledysk':
																return (
																	<div className=' max-w-md drop-shadow-lg'>
																		{data.map(
																			(
																				resultData,
																				i
																			) => {
																				return i ===
																					0 ? (
																					<div
																						key={
																							i +
																							resultData.name
																						}
																						className={`flex flex-row flex-wrap w-fit h-46 relative z-20 justify-evenly border-[#503854] border-2 border-solid text-stone-200 drop-shadow-xl rounded bg-gradient-to-t from-[#f9b866] to-[#503854]`}
																					>
																						<div className='relative flex flex-col-reverse justify-end drop-shadow-2xl'>
																							<div className='w-fit mx-2 font-[Light] text-l uppercase'>
																								{
																									category
																								}
																							</div>
																							<div className='w-fit mx-2 pr-20 font-[Bold] text-xl text-left'>
																								{
																									resultData.name
																								}
																							</div>
																						</div>
																						<div className='flex flex-col-reverse mb-[1px] w-full text-end font-[Bold] text-xl'>
																							<div className='h-6 w-full self-end text-center mb-[7px]'>
																								<div className='text-[#503854] text-right mr-1'>
																									{resultData.votesPercentage +
																										'%'}
																								</div>
																								<div className='w-full h-1 rounded-full bg-[#5038544a] float-right'>
																									<div
																										className={`h-1 rounded-full bg-[#503854] float-right`}
																										style={{
																											width: `${resultData.votesPercentage}%`,
																										}}
																									></div>
																								</div>
																							</div>
																							<div className='mx-1 self-end'>
																								{
																									<iframe
																										src={`https://www.youtube-nocookie.com/embed/${resultData.video}?enablejsapi=1`}
																										className='border-[#503854] border-2 rounded'
																										title='YouTube video player'
																										allowFullScreen={
																											true
																										}
																										referrerPolicy='no-refferer'
																										sandbox='allow-scripts allow-same-origin'
																										loading='lazy'
																									/>
																								}
																							</div>
																						</div>
																					</div>
																				) : (
																					<div
																						key={
																							i +
																							resultData +
																							i
																						}
																						className={`flex flex-col border-x min-h-[85px] relative pt-1 w-50 ${
																							i ===
																								1 &&
																							'z-10'
																						} text-[#503854] justify-between -mt-1 bg-[#f9b866] border-[#503854] border-b ${
																							i ===
																								2 &&
																							'bg-gradient-to-b from-[#f9b866] to-[#e2ce9d]'
																						} rounded`}
																					>
																						<div className='border-solid border-black self-start w-fit mx-2 font-[Bold] text-l'>
																							{
																								resultData.name
																							}
																						</div>
																						<div className='w-full self-end font-[Bold] text-xl'>
																							<div className='text-right mr-1'>
																								{resultData.votesPercentage +
																									'%'}
																							</div>
																							<div className='w-full h-1 rounded-full bg-[#5038544a]'>
																								<div
																									className={`h-1 rounded-full bg-[#503854] float-right`}
																									style={{
																										width: `${resultData.votesPercentage}%`,
																									}}
																								></div>
																							</div>
																						</div>
																					</div>
																				);
																			}
																		)}
																	</div>
																);
															default:
																return (
																	<div className='w-80 drop-shadow-lg'>
																		{data.map(
																			(
																				resultData,
																				i
																			) => {
																				return i ===
																					0 ? (
																					<div
																						className='flex flex-col w-50 h-40 relative z-20 justify-between border-[#503854] border-2 border-solid text-stone-200 drop-shadow-xl rounded bg-gradient-to-t from-[#f9b866] to-[#503854]'
																						key={
																							resultData.name
																						}
																					>
																						<div
																							className={`flex flex-row relative z-20 justify-between  `}
																						>
																							<div className='relative flex flex-col-reverse justify-end drop-shadow-2xl'>
																								<div className='w-fit mx-1 font-[Light] text-l uppercase'>
																									{
																										category
																									}
																								</div>
																								<div className='w-fit mx-1 font-[Bold] text-l text-left'>
																									{
																										resultData.name
																									}
																								</div>
																							</div>
																							<div className='mr-1 w-fit flex flex-col-reverse text-center self-center font-[Light] text-xl'>
																								<div className='w-32 text-xl'>
																									<img
																										className='w-32 rounded border-[#503854] border-2'
																										src={`${process.env.REACT_APP_API_DOMAIN}/images/${resultData.image}`}
																									/>
																								</div>
																							</div>
																						</div>
																						<div className='text-[#503854] font-[Bold] text-xl text-right mr-1 -mb-1'>
																							{resultData.votesPercentage +
																								'%'}
																						</div>
																						<div className='w-full rounded-full h-1 bg-[#5038545b]'>
																							<div
																								className={`h-1 rounded-full bg-[#503854] float-right`}
																								style={{
																									width: `${resultData.votesPercentage}%`,
																								}}
																							></div>
																						</div>
																					</div>
																				) : (
																					<div
																						key={
																							resultData.name +
																							i
																						}
																						className={`flex flex-col border-x min-h-[85px] relative pt-1 w-50 ${
																							i ===
																								1 &&
																							'z-10'
																						} text-[#503854] justify-between -mt-1 bg-[#f9b866] border-[#503854] border-b ${
																							i ===
																								2 &&
																							'bg-gradient-to-b from-[#f9b866] to-[#e2ce9d]'
																						} rounded`}
																					>
																						<div className='border-solid border-black self-start w-fit mx-2 font-[Bold] text-l'>
																							{
																								resultData.name
																							}
																						</div>
																						<div className='w-full self-end font-[Bold] text-xl'>
																							<div className='text-right mr-1'>
																								{resultData.votesPercentage +
																									'%'}
																							</div>
																							<div className='w-full h-1 rounded-full bg-[#5038544a]'>
																								<div
																									className={`h-1 rounded-full bg-[#503854] float-right`}
																									style={{
																										width: `${resultData.votesPercentage}%`,
																									}}
																								></div>
																							</div>
																						</div>
																					</div>
																				);
																			}
																		)}
																	</div>
																);
														}
													});
											}
										)}
									</div>
								</div>
							</div>
						)}

						<div className='text-center text-sm uppercase text-white font-[Bold] flex flex-wrap justify-around'>
							<div className='w-full'>
								{oldResultsYears.reverse()?.map((year) => {
									return (
										<div
											className='flex flex-wrap justify-center gap-2 '
											key={year}
										>
											{/* Older then last year results */}
											<div className='flex flex-wra flex-col w-full'>
												<div className='p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]'>
													<div className='p-1 font-[Bold] uppercase text-gray-50'>
														{year}
													</div>
												</div>
												<div className='flex flex-wrap justify-around gap-1'>
													{votingCategories?.map(
														(category) => {
															return oldResults
																.filter(
																	(result) =>
																		result.category ===
																			category &&
																		result.year ===
																			year
																)
																.map(
																	(
																		resultData,
																		i
																	) => {
																		return (
																			i ===
																				0 && (
																				<div
																					key={
																						resultData.name +
																						i
																					}
																					className='border-solid border-2 border-[#503854] text-[#ffffff] bg-gradient-to-t from-[#f9b866] to-[#503854] rounded p-1 w-[140px] h-fit flex flex-col flex-wrap justify-between mt-3 shadow-xl  font-[Light]'
																				>
																					<div className='-mt-1'>
																						{
																							category
																						}
																					</div>
																					{category ===
																					'teledysk' ? (
																						<iframe
																							src={`https://www.youtube-nocookie.com/embed/${resultData.video}?enablejsapi=1`}
																							className='border-[#503854] w-[128px] h-32 rounded'
																							title='YouTube video player'
																							allowFullScreen={
																								true
																							}
																							referrerPolicy='no-refferer'
																							sandbox='allow-scripts allow-same-origin allow-presentation'
																							loading='lazy'
																						/>
																					) : (
																						<img
																							className='rounded border-[#503854] border'
																							src={`${process.env.REACT_APP_API_DOMAIN}/images/${resultData.image}`}
																						/>
																					)}
																					<div className='font-[Bold] mt-2 text-black'>
																						{
																							resultData.name
																						}
																					</div>
																				</div>
																			)
																		);
																	}
																);
														}
													)}
												</div>
											</div>
										</div>
									);
								})}
							</div>
							{/* oldest result no db */}
							<div className='flex flex-wra flex-col w-full'>
								{olderResultsYears.flatMap((year) => {
									return (
										<div
											className='flex-row text-center text-sm uppercase text-white font-[Bold] mt-2'
											key={year + '-'}
										>
											<div className='p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]'>
												<div className='p-1 font-[Bold] uppercase text-gray-50'>
													{year}
												</div>
											</div>

											<div className='flex flex-wrap justify-around'>
												{votingCategories.map(
													(category) => {
														return olderResults
															.filter(
																(oldResult) =>
																	oldResult._id ===
																		category &&
																	oldResult.year ===
																		year
															)
															.map(
																(
																	oldResultsByCategories,
																	i
																) => {
																	return (
																		<div
																			key={
																				oldResultsByCategories.name +
																				i
																			}
																			className='border-solid border-2 border-[#503854] text-[#ffffff] bg-gradient-to-t from-[#f9b866] to-[#503854] rounded p-1 w-[140px] h-fit flex flex-col flex-wrap justify-between mt-3 shadow-xl  font-[Light]'
																		>
																			<div className=' -mt-1'>
																				{
																					category
																				}
																			</div>
																			{
																				<img
																					className='rounded border-[#503854] border'
																					src={`${process.env.REACT_APP_API_DOMAIN}${oldResultsByCategories.image}`}
																				/>
																			}
																			<div className='font-[Bold] mt-2 text-black'>
																				{
																					oldResultsByCategories.name
																				}
																			</div>
																		</div>
																	);
																}
															);
													}
												)}
											</div>
										</div>
									);
								})}
							</div>

							{/* {votingCategories.map((category) => {

                return oldResults
                  .filter((result) => result._id === category)
                  .map((lastYearResultByCategory) => {
                    const category = lastYearResultByCategory._id;

                    console.log(lastYearResultByCategory.year);
                    switch (category) {
                      default: {
                        return lastYearResultByCategory.map((resultData, i) => {
                          return (
                            i === 0 && (
                              <div key={resultData.name + i} className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                                {category === "teledysk" ? (
                                  // <iframe
                                  //   src={`https://www.youtube-nocookie.com/embed/${resultData.video}?enablejsapi=1`}
                                  //   className="border-[#503854] border-2 w-32 h-32 rounded"
                                  //   title="YouTube video player"
                                  //   allowFullScreen={true}
                                  //   referrerPolicy="no-refferer"
                                  //   sandbox="allow-scripts allow-same-origin allow-presentation"
                                  //   loading="lazy"
                                  // />
                                  <></>
                                ) : (
                                  <img
                                    className="rounded"
                                    src={`${process.env.REACT_APP_API_DOMAIN}/images/${resultData.image}`}
                                  />
                                )}
                                <div className="font-[Bold] mt-2">
                                  {resultData.name}
                                </div>
                              </div>
                            )
                          );
                        });
                      }
                    }
                  });
              })} */}
						</div>

						{/* <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] rounded font-[Light]">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2021</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_artysta_peja.jpg`}
                />
                <div className="font-[Bold] mt-2">PEJA/SLUMS ATTACK</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_producent_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_album_peja_nalegalu.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - NA LEGALU
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_teledysk_flowmustgoon.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK FEAT. DONGURALESKO - FLOW MUST GO ON
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2021_impreza_45urodzinyrycha.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK + GOŚCIE (45 URO RYCHA)
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/wydarzenie_2021_wydanie_nalegalu_na_20lecie_albumu.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  WYDANIE "NA LEGALU" NA 20-LECIE ALBUMU
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2020</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_artysta_peja.jpg`}
                />
                <div className="font-[Bold] mt-2">PEJA</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_producent_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_album_pejablackalbum.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - BLACK ALBUM
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_teledysk_richtown.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - RICHTOWN FEAT. GANDZIOR, KOBRA, RESPO,
                  DEEP, BANDURA, GRZYBEK, SIMPSON, BJN, PELEOKO, HANS, FAZI,
                  ICEMAN
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2020_impreza_44uro_rycha.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  KONCERT PEJA/SLUMS ATTACK (44 URO RYCHA)
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/wydarzenie_2020_trzy_plyty_od_peji.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  TRZY PŁYTY OD PEJI W 2020 ROKU
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2019</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_artysta_paluch.jpg`}
                />
                <div className="font-[Bold] mt-2">PALUCH</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_producent_julas.jpg`}
                />
                <div className="font-[Bold] mt-2">JULAS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_album_borcrewalbum.jpg`}
                />
                <div className="font-[Bold] mt-2">BORCREW ALBUM</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_teledysk_paluch_tiry.jpg`}
                />
                <div className="font-[Bold] mt-2">PALUCH - "TIRY"</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_impreza_hiphopfever2.jpg`}
                />
                <div className="font-[Bold] mt-2">HIP-HOP FEVER 2</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2019_wydarzenie_wydanie_borcrew_album.jpg`}
                />
                <div className="font-[Bold] mt-2">WYDANIE BORCREW ALBUM</div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2018</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_artysta_pejaslumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">PEJA/SLUMS ATTACK</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_producent_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_dj_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_album_peja_slumsattack_25h.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - 25_GODZIN
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_teledysk_peja_slumsattack_gluchanoc2.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - GŁUCHA NOC 2
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_impreza_peja_25lat_na_scenie.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  25 LAT NA SCENIE PEJI/SLUMS ATTACK (27.10)
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2018_wydarzenie_25latpracyscenicznejpeji.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  25 LAT PRACY SCENICZNEJ RYCHA PEJI
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2017</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_artysta_peja.jpg`}
                />
                <div className="font-[Bold] mt-2">PEJA</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_producent_adash.jpg`}
                />
                <div className="font-[Bold] mt-2">ADASH</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_dj_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_album_peja_slumsattack_brahu_remisja.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK - "REMISJA"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_teledysk_peja_slumsattack_borysewicz_1976.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PEJA/SLUMS ATTACK FEAT. JAN BORYSEWICZ - "1976"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2017_impreza_tojesthiphopdjdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  TO JEST HIP HOP. 20 LAT DJ DECKS`A
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_wydarzenie_onyx_mastaace_slumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PREMIERA ALBUMU PEJA/SLUMS ATTACK - "REMISJA"
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2016</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_artysta_paluch.jpg`}
                />
                <div className="font-[Bold] mt-2">PALUCH</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_producent_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_dj_soina.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ SOINA</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_album_paluch_zlotaowca.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  PALUCH - "OSTATNI KRZYK OSIEDLA"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_teledysk_jagla_bjn_gedz_hologramy.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  JAGŁA X BJN FEAT. GEDZ - "HOLOGRAMY"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_impreza_hiphopfever.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  HIPHOP FEVER (40 URODZINY RYCHA PEJI)
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2016_wydarzenie_dwie_platyny_palucha.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DWIE PLATYNY W JEDNYM ROKU DLA PALUCHA
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2015</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_artysta_peja.jpg`}
                />
                <div className="font-[Bold] mt-2">slums attack</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_producent_julas.jpg`}
                />
                <div className="font-[Bold] mt-2">JULAS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_dj_soina.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ SOINA</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_album_donguralesko_magnumignotum.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DONGURALESKO - "MAGNUM IGNOTUM"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_teledysk_deep_bobson_wznosisiekurz.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DEEP X BOBSON - "WZNOSI SIĘ KURZ" FEAT. CHUPA
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_impreza_terrorymfever5.jpg`}
                />
                <div className="font-[Bold] mt-2">TERRORYM FEVER 5</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2015_wydarzenie_rozpad_slums_attack.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  INFORMACJA O ROZPADZIE SLUMS ATTACK
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2014</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_artysta_peja.jpg`}
                />
                <div className="font-[Bold] mt-2">PEJA</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_producent_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_album_rps_ksiaze_slumillioner.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  RPS/WHR - "KSIĄŻĘ AKA. SLUMILIONER"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_teledysk_zbuku_sliwa_mlodakrew.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  ZBUKU FEAT. ŚLIWA, SZTOSS - "MŁODA KREW"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_impreza_poznanhiphopfestiwal.jpg`}
                />
                <div className="font-[Bold] mt-2">POZNAŃ HIP HOP FESTIWAL</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2014_wydarzenie_hot16challange.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  UDZIAŁ POZNAŃSKICH ARTYSTÓW W AKCJI #HOT16CHALLANGE
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2013</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_artysta_slumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">slums attack</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_producent_mikser.jpg`}
                />
                <div className="font-[Bold] mt-2">MIKSER</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_album_demonologia2.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DEMONOLOGIA (SŁOŃ/MIKSER) - "DEMONOLOGIA 2"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_teledysk_evergreen.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  SLUMS ATTACK - "EVERGREEN"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_impreza_20latslu.jpg`}
                />
                <div className="font-[Bold] mt-2">20 LAT SLUMS ATTACK</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2013_wydarzenie_20latslu.jpg`}
                />
                <div className="font-[Bold] mt-2">20 LAT SLUMS ATTACK</div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2012</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_artysta_slumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">slums attack</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_producent_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_album_slumsattack_cno2.jpg`}
                />
                <div className="font-[Bold] mt-2">SLUMS ATTACK - "CNO2"</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_teledysk_donguralesko_chcecidac.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DONGURALESKO - "CHCĘ CI DAĆ"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_impreza_terrorymfever3.jpg`}
                />
                <div className="font-[Bold] mt-2">TERRORYM FEVER 3</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2012_wydarzenie_onyx_mastaace_slumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  ONYX I MASTA ACE NA PŁYCIE SLUMS ATTACK
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2011</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_artysta_slumsattack.jpg`}
                />
                <div className="font-[Bold] mt-2">slums attack</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_producent_djdecks.jpg`}
                />
                <div className="font-[Bold] mt-2 ">DJ DECKS</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_album_slumsattack_reedukcja.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  SLUMS ATTACK - "REEDUKACJA"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_teledysk_slumsattack_oddalbym.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  SLUMS ATTACK FEAT.O.S.T.R., JERU THE DAMAJA - "ODDAŁBYM"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_impreza_terrorymfever2.jpg`}
                />
                <div className="font-[Bold] mt-2">TERRORYM FEVER 2</div>
              </div>
              <div className="p-2 w-36 max-h-50 flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2011_wydarzenie_slumsattack_reedukacja.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  WYDANIE PRZEZ SLUMS ATTACK ALBUMU "REEDUKACJA"
                </div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2010</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_artysta_slon.jpg`}
                />
                <div className="font-[Bold] mt-2 text-gray-50">SŁOŃ</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_producent_mikser.jpg`}
                />
                <div className="font-[Bold] mt-2">mikser</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_album_slon_mikser_demonologia.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  SŁOŃ & MIKSER - "DEMONOLOGIA"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_teledysk_rps_pozwolmizyc.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  RPS FEAT.GLACA, ANA HERRERO - "POZWÓL MI ŻYĆ (SĄ CHWILE)
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_impreza_terrorymfever.jpg`}
                />
                <div className="font-[Bold] mt-2">terrorym fever</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2010_wydarzenie_beef_pejatede.jpg`}
                />
                <div className="font-[Bold] mt-2">BEEF PEJA VS. TEDE</div>
              </div>
            </div>

            <div className="p-1 flex flex-wrap justify-around mt-5 bg-[#503854] font-[Light] rounded">
              <div className="p-1 font-[Bold] uppercase text-gray-50">2009</div>
            </div>
            <div className="flex flex-wrap justify-around">
              <div className="bg-gradient-to-b from-[#f9b866] to-[#503854] rounded p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-[#503854] font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_artysta_donguralesko.jpg`}
                />
                <div className="font-[Bold] mt-2">gural</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_producent_matheo.jpg`}
                />
                <div className="font-[Bold] mt-2">matheo</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_dj_decks.jpg`}
                />
                <div className="font-[Bold] mt-2">dj decks</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_album_slon_choremelodie.jpg`}
                />
                <div className="font-[Bold] mt-2">SŁOŃ - "CHORE MELODIE"</div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_teledysk_tomiasto.jpg`}
                />
                <div className="font-[Bold] mt-2">
                  DJ STORY, SHELLER, SŁOŃ, RAMONA 23, PALUCH, KOBRA, OLDAS,
                  PELE, GANDZIOR - "TO MIASTO"
                </div>
              </div>
              <div className="p-2 w-36 h-fit flex flex-col flex-wrap justify-between mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_impreza_blackxmas3.jpg`}
                />
                <div className="font-[Bold] mt-2">BLACK X-MAS 3</div>
              </div>
              <div className="p-2 w-36 flex flex-col flex-wrap justify-between h-fit mt-5 bg-gradient-to-b from-[#f9b866] to-[#503854] rounded  font-[Light]">
                <img
                  className="rounded"
                  src={`${process.env.REACT_APP_API_DOMAIN}/images/2009_wydarzenie_beef_pejatede.jpg`}
                />
                <div className="font-[Bold] mt-2">BEEF PEJA VS. TEDE</div>
              </div>
            </div> */}
					</div>
					<div className='p-1 mb-5 w-full mt-5 drop-shadow-xl bg-[#503854] rounded' />
				</div>
			</div>
		</>
	);
};

export default Results;
